import { messages } from './messages';

export const RequestedService = {
  messageDescriptor: messages.requestedService,
  id: 'requested-service',
};
